import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const addAdvanceData = async (advanceData) => {
  try {
    const res = await API.add_publisher_advance(advanceData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const publisherAdvanceList = async (page, month) => {
  try {
    const res = await API.publisher_advance_list(page, month);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublisherAdvanceDetails = async (ID) => {
  try {
    const res = await API.publisher_advance_details(ID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateAdvanceData = async (ID, advanceData) => {
  try {
    const res = await API.update_publisher_advance(ID, advanceData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};